import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./broadcastConfirmModal.module.css";
import venchyImg from "../../../images/questionnaire_doctor.png";

interface BroadcastConfirmModalProps {
  onConfirmAll: () => void;
  onConfirmCurrent: () => void;
  onClose: () => void;
  // The save behind these buttons waits for the message to be translated, which can take
  // several seconds. Without locking them the screen looks idle, a second click goes out, and
  // each click inserts its own copy of the message.
  isSaving?: boolean;
}

function BroadcastConfirmModal({
  onConfirmAll,
  onConfirmCurrent,
  onClose,
  isSaving = false,
}: BroadcastConfirmModalProps) {
  return (
    <article className={popupStyles.popup} data-testid="broadcast-confirm-popup">
      <img className={popupStyles.popup__img} src={venchyImg} alt={t("VENCHI")} />
      <h2 className={popupStyles.popup__title}>{t("CONFIRM_BROADCAST_TITLE")}</h2>
      <p className={popupStyles.popup__text}>{t("CONFIRM_BROADCAST_MESSAGE")}</p>
      <div className={popupStyles.popup__buttons}>
        <button
          className={`button ${popupStyles.popup__btn} ${popupStyles.popup__btnPrimary} hover`}
          data-testid="broadcast-all-button"
          disabled={isSaving}
          onClick={() => {
            onConfirmAll();
          }}
        >
          {isSaving ? t("LOADING_LABEL") : t("SEND_TO_ALL_COMPANIES")}
        </button>
        <button
          className={`button ${popupStyles.popup__btn} ${popupStyles.popup__btnSecondary} hover`}
          data-testid="broadcast-current-button"
          disabled={isSaving}
          onClick={() => {
            onConfirmCurrent();
          }}
        >
          {isSaving ? t("LOADING_LABEL") : t("SEND_TO_CURRENT_COMPANY")}
        </button>
      </div>
    </article>
  );
}

export default BroadcastConfirmModal;
